import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InfoService } from 'src/app/_services/info.service';

@Component({
  selector: 'app-info-legal',
  templateUrl: './info-legal.component.html',
  styleUrls: ['./info-legal.component.css']
})
export class InfoLegalComponent implements OnInit {

  data: any={};
  urlPadre: any;
  idUrl: Number;
  parrafos: Array<string>

  constructor(
    public route: ActivatedRoute,
    private infoService:InfoService 
  ) {
    this.route.url.subscribe(params => {
      this.urlPadre = params[0].path;
    })
  }

  ngOnInit(): void {
    this.setIdUrl();
    this.getInfoData()
  }


  private getInfoData(): void {
    return this.infoService.getInfoById(this.idUrl).subscribe({
      next: (obj) => {
        this.data = obj['Informacion'];
        this.parrafos = this.data.cuerpo/*.toString().split('\r')
        this.parrafos.forEach((parr, index) => {
          console.warn(parr.length);
          
          if (parr.length === 1) {
            this.parrafos.splice(index, 1)
          }
        })*/
      },
      error: (err) => {
      }
    });
  }


  private setIdUrl() {
    switch (this.urlPadre) {
      case "aviso-legal":
        this.idUrl = 1;
        break;
      case "politica-privacidad":
        this.idUrl = 2;
        break;
      case "proteccion-de-datos":
        this.idUrl = 3;
        break;
      case "terminos-registro-general":
        this.idUrl = 5;
        break;
      case "terminos-seleccion-personal":
        this.idUrl = 4;
        break;
    }
  }
}
